<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">HRClosure Details</h4>
        
      </div>
       <div class="mb-3 text-center mt-4">
    <button class="btn btn-success me-2" (click)="GetOnboardingGrid()">
      <i class="fa fa-eye me-1"></i> Onboarding Data
    </button>
    <button class="btn btn-primary me-2" (click)="GetOffboardingGrid()">
      <i class="fa fa-file-excel me-1"></i> Offboarding Data
    </button>
     <button class="btn btn-primary me-2" (click)="GetRolechangeGrid()">
      <i class="fa fa-file-excel me-1"></i> Role Change
    </button>
    </div>
       <!-- <button type="submit" class="btn btn-submit" (click)="GetOnboardingGrid()" >Onboarding Data</button>
        <button type="submit" class="btn btn-reject" (click)="GetOffboardingGrid()" >Offboarding Data</button>-->
      <!-- Employee Table -->
       <div class="row mb-4">
       <div class="table-responsive modern-table-container">
  <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Emp Code</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Department</th>
            <th>Requested By</th>
            <th>Date of Joining</th>
            <th>Checker</th>
            <th>Approver</th>
            <th>AD Username</th>
            <th>Mail ID</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.hrclosuredata; let i = index">
            <!-- Index -->
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td class="text-center"><div class="Dropdown">
              <button class="icon-button me-1" ([ngModel])="appservice.hrclosureeditid" (click)="editEmployee(emp.OD_iid)" title="Edit">
    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
  </button>
  </div>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.OD_EmployeeID }}</td>
            <td>{{ emp.OD_Full_Name }}</td>
            <td>{{ emp.OD_Designation }}</td>
            <td>{{ emp.OD_Grad }}</td>
            <td>{{ emp.OD_Department }}</td>
            <td>{{ emp.OD_OnboardingCreatedby }}</td>
            <td>{{ emp.OD_Dateofjoin }}</td>
            
            <td>{{ emp.OD_ReportingTo_Name }}</td>
            <td>{{ emp.OD_FinalApprovedby }}</td>
            <td>{{ emp.OD_ITAD_AccountName }}</td>
            <td>{{ emp.OD_CMailid }}</td>
          </tr>
        </tbody>
      </table>
</div>
</div>
    
  </div>
</div>
